import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, TextField, Paper } from '@mui/material';
import { useTranslation } from 'src/i18n';

// The four deficiency codes are fixed by the form, and each has a fixed meaning, so both are
// part of the form rather than data. Only the colour is entered, in extras.highlightColors.
const CODE_KEYS = ['code1', 'code2', 'code3', 'code4'];

// Section 2's highlight-colour legend.
export default function EhtInsulationAuditHighlightColors (props) {
  const { data, onChange, readOnly } = props;
  const { t } = useTranslation();

  const rows = useMemo(() => CODE_KEYS.map(key => ({
    key,
    code: t(`ehtInsulationAudit.deficiency.${key}`),
    deficiency: t(`ehtInsulationAudit.deficiencyMeaning.${key}`),
  })), [t]);

  const colors = data?.get('highlightColors');

  return (
    <Paper className='field-report-section'>
      <h3>{t('ehtInsulationAudit.highlightColors')}</h3>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className='main-headers'>{t('ehtInsulationAudit.highlightColorsTable.code')}</TableCell>
              <TableCell className='main-headers'>{t('ehtInsulationAudit.highlightColorsTable.deficiency')}</TableCell>
              <TableCell className='main-headers'>{t('ehtInsulationAudit.highlightColorsTable.color')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <TableRow key={row.key}>
                <TableCell className='sub-headers'>{row.code}</TableCell>
                <TableCell>{row.deficiency}</TableCell>
                <TableCell className='body-cell'>
                  <TextField
                    fullWidth
                    disabled={readOnly}
                    value={colors?.get(row.key) || ''}
                    onChange={(e) => onChange(['extras', 'highlightColors', row.key], e.target.value)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

EhtInsulationAuditHighlightColors.propTypes = {
  data: ImmutablePropTypes.map,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

EhtInsulationAuditHighlightColors.defaultProps = {
  readOnly: false,
};
